import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ElementRef, HostListener, ViewChild, AfterViewChecked, AfterContentChecked } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { MainLayoutService } from '../services/main-layout.service';
import { AuthenticationService } from 'src/app/security/services/authentication.service';
import { filter, takeUntil } from 'rxjs/operators';
import { BaseConfig, FunctionEnable } from 'src/app/services/base-config.service';
import { EasyNotificationService, NotifyMessage } from 'src/app/services/easy-notification.service';
import { Router, NavigationEnd, DefaultUrlSerializer, UrlSegmentGroup, UrlSegment, ActivatedRoute } from '@angular/router';
import { UserCache } from 'src/app/services/user-cache';
import { ClinicTypeEnum } from 'src/app/enums/ClinicTypeEnum';
import { WebApiClient } from 'src/app/services/web-api-client.service';

import { LoginMenu } from 'src/app/permission/models/login-menu';
import { MenuComponent } from '../menu/menu.component';
import { HcrService } from 'src/app/services/hcr-service.service';
import { ConfirmData, UserConfirmService } from 'src/app/services/user-confirm.service';
import { LocalPrintService } from 'src/app/services/local-print.service';
import { StartUpService } from 'src/app/services/start-up-service';
import { ReportHelperComponent } from 'src/app/system/report/report-helper/report-helper.component';
import { RouteInfoService } from 'src/app/services/route-info.service';
import { FontGreatService } from 'src/app/services/font-great.service';
import { HistService } from 'src/app/hist/services/hist.service';
import { PatientSelectService } from 'src/app/services/patient-select.service';
import { PatientListDto } from 'src/app/services/api-service/patient/patient-api';
import { QueryPatient } from 'src/app/services/api-service/patient/patientsDto';
import { TutorialService, TutorialTip } from 'src/app/services/tutorial-service';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { VisDialogComponent } from 'src/app/shared/components/dialog/vis-dialog/vis-dialog.component';
import { CustomResult } from 'src/app/shared/models/custom-result';
import { UserRoleFunctionService } from 'src/app/services/data-service/user-role-function.service';
import { QrcodeReaderComponent } from 'src/app/card-reader/qrcode-reader/qrcode-reader.component';
import { NotifySoundComponent } from 'src/app/shared/components/notify-sound/notify-sound.component';
import { delay, SHA256 } from 'src/app/shared/utilities';
import { HotKeyService, Priority } from 'src/app/services/hotkey-service';
import { SessionService } from 'src/app/services/session.service';
import { LoaderComponent } from '../loader/loader.component';
import { MenuApiService } from 'src/app/services/api-service/permission/menu-api.service';

import { AllowAllRoleFunction } from 'src/app/models/UserRoleFunction';

import { PatientInfoWindowDentalFollowRequest, PatientInfoWindowEditRequest, PatientInfoWindowLayout, PatientInfoWindowReserveRecordRequest, PatientInfoWindowReserveRequest, PatientInfoWindowService, PatientInfoWindowState } from 'src/app/services/patient-info-window.service';
import { PatientConst } from 'src/app/shared/constants/patient-const';
import { EasyFormService } from 'src/app/services/easy-form-service';
import { LoginStockAlertDto } from 'src/app/stocks/product/models/product';


@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements OnInit, OnDestroy {

  @ViewChild('printHelper')
  printHelper: ReportHelperComponent;

  @ViewChild('mainContent')
  mainContent: ElementRef<HTMLDivElement>;

  @ViewChild('qrcode')
  QRCodeScanner: VisDialogComponent;
  @ViewChild('qrcodeReaderDiag')
  QRCodeReaderDiag: VisDialogComponent;
  @ViewChild('qrcodeReader')
  QRCodeReader: QrcodeReaderComponent;
  @ViewChild('notifySound')
  notifySound: NotifySoundComponent;
  @ViewChild('loader')
  loaderComp: LoaderComponent;
  isopened = true;
  isShowMarquee = (new Date().getTime()) < (new Date('2024-09-22 07:00:00').getTime());
  showGuard = false;
  isStockAlertDialogOpened = false;
  /** 登入庫存警示檢查結果 (頁籤徽章筆數) */
  stockAlertCounts: LoginStockAlertDto = null;
  stockAlertTab: 'lowStock' | 'batchExpiry' | 'inactiveBatch' = 'lowStock';
  /** 是否顯示批號效期頁籤 (STK001 啟用批號效期管理) */
  showBatchExpiryTab = false;
  /** 0 停用 1:動一下收起來 2:輸入密碼 */
  screenGuardType = 0;
  screenGuardWaitS = 10;
  screenGuardTimeout = null;
  idleMSCounter = 0;
  //private api: WebApiService;
  private menu: LoginMenu;
  isShowLoader$ = this.mainLayoutService.isShowLoader$
  isEasyFormShown$ = this.easyFormService.isShown$;

  isDental: boolean = (UserCache.getLoginUser().Clinic.Type == ClinicTypeEnum.DentistClinic);
  isPatientInfoClinic: boolean = UserCache.getLoginUser().Clinic?.Type == ClinicTypeEnum.DentistClinic
    || UserCache.getLoginUser().Clinic?.Type == ClinicTypeEnum.WesternAndDentistClinic;
  enableDesktopPet = false;
  isDebug = BaseConfig.isDebug();
  patientInfoWindowState: PatientInfoWindowState = {
    visible: false,
    selectedPatient: null,
    selectedRegisterItem: null,
    patientId: 0,
    enableEdit: true,
    memoryScope: 'global',
    refreshToken: 0,
    refreshPatientId: 0
  };
  patientInfoPinnedLayout: PatientInfoWindowLayout | null = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private mainLayoutService: MainLayoutService,
    private easyFormService: EasyFormService,
    private auth: AuthenticationService,
    private notificationDI: EasyNotificationService,
    private webApiFactory: WebApiClient,
    private hcrService: HcrService,
    private userConfirmService: UserConfirmService,
    private patientSelectService: PatientSelectService,
    private tutorialService: TutorialService,
    private printService: LocalPrintService,
    private startUp: StartUpService,
    private fontGreatService: FontGreatService,
    private keyService: HotKeyService,
    private histService: HistService,
    private routeInfoService: RouteInfoService,
    private clinicData: ClinicDataService,
    private sessionSerivce: SessionService,
    private userRoleFunctionService: UserRoleFunctionService,
    private menuApi: MenuApiService,
    private patientInfoWindowService: PatientInfoWindowService,
  ) {

    mainLayoutService.mainlayoutComp = this;
    this.userConfirmService.mainlayout = this;
    this.patientSelectService.mainLayoutCmp = this;
    this.tutorialService.mainLayoutCmp = this;
    // mainLayoutService.pageTitle$.pipe(takeUntil(this.unsubscribe)).subscribe(
    //   pageTitle => {
    //     setTimeout(() => {
    //       if (pageTitle == null) {
    //         this.updatePageTitle()
    //       } else {
    //         this.pageTitle = pageTitle;
    //       }

    //     }, 0);
    //   }
    // );
    mainLayoutService.isShowMenu$.pipe(takeUntil(this.unsubscribe)).subscribe(
      isShowMenu => {
        this.isShowMenu = isShowMenu;
        this.updateMenuCSS();
      }
    );
    this.switchMenuSubscription = this.mainLayoutService.switchMenu$.subscribe(
      (b) => {
        if (b) {
          this.isShowMenu = !this.isShowMenu;
          this.updateMenuCSS();
        }
      }
    );
    this.notification = this.notificationDI;
    this.notification.OnMessage.subscribe((msg) => {
      // 此元件支援的呈現模式
      if (this.isSupportedNotifyStyle) {
        this.msgs.push(msg);
        if (this.notifyStack) {
          setTimeout(() => {
            for (let i = 0; i < this.msgs.length; i++) {
              this.收合Msg(this.snackDiv.get(i).nativeElement, i)
            }
          }, 0);
        }
      }
    })
    this.notification.OnCloseMessage.subscribe((id) => {
      this.closeMsgById(id);
    })
    // console.log('main layout loaded')
    this.routerHandler(router);

    //this.api = this.webApiFactory.createHisService('permission/menu');
    this.patientInfoWindowService.state$.pipe(takeUntil(this.unsubscribe)).subscribe(state => {
      this.patientInfoWindowState = state;
    });
    this.patientInfoWindowService.reserveRecordNavigation$.pipe(takeUntil(this.unsubscribe)).subscribe(request => {
      this.onPatientInfoReserveRecordNavigation(request);
    });

  }

  notification: EasyNotificationService;

  private unsubscribe: Subject<void> = new Subject();
  private switchMenuSubscription: Subscription;

  get isUseTopMenu(): boolean {
    if (BaseConfig.getConfig().env.menuType === 'top') {
      return true;
    } else {
      return false;
    }
  }

  get isUseLeftMenu(): boolean {
    if (BaseConfig.getConfig().env.menuType === 'left') {
      return true;
    } else {
      return false;
    }
  }
  isShowPageTitle: boolean;
  pageTitle = '';
  isShowMenu = true;
  error: any = null;
  isLoaded = false;
  layoutForMenuCssClass = '';
  isHist: boolean = false;

  onDoubleClick() {
    if (this.isopened) this.isopened = false;
    else this.isopened = true;
  }
  async onClickMarquee() {
    var msgcon = '為了提供更完善的服務\n' +
      '將配合微軟進行機房轉移作業\n' +
      '轉移過程會暫時停止系統服務\n' +
      '暫停時間：2024/09/21(六) 23:00 ~ 2024/09/22(日) 07:00\n\n' +
      '如作業提前完成，將會提前恢復服務\n' +
      '造成您的不便，敬請見諒';
    var ret = await this.userConfirmService.showConfirm({
      title: '公告',
      msg: msgcon,
      width: 450,
      textYes: '確認',
      hideNo: true
    });
  }
  updateMenuCSS() {
    // 避免因為其他Subscribe改變狀態引起ExpressionChangedAfterItHasBeenCheckedError
    // 所以統一扔到下一個生命周期進行
    setTimeout(() => {
      if (!this.isUseTopMenu) {
        this.layoutForMenuCssClass = 'without-top-menu';
      }
      if (this.isShowMenu) {
        this.layoutForMenuCssClass = '';
      } else {
        this.layoutForMenuCssClass = 'without-top-menu';
      }
    }, 0);
  }


  async ngOnInit() {

    document.body.classList.toggle('dental-clinic-theme', this.isDental);

    var s = this.startUp.onParameterLoaded.subscribe(async () => {
      await this.updateNotifyMode()
      s.unsubscribe();
    })

    // 訂閱庫存警示事件 (庫存不足 + 批號效期)
    this.startUp.onStockAlertDetected.pipe(takeUntil(this.unsubscribe)).subscribe(async (result) => {
      this.stockAlertCounts = result;
      const stk001 = await this.clinicData.getParam('STK001');
      this.showBatchExpiryTab = !!(stk001 && stk001.EnableBatchManagement);
      // 預設開在有資料的頁籤，庫存不足優先
      this.stockAlertTab = result.LowStockCount > 0 ? 'lowStock' : 'batchExpiry';
      this.isStockAlertDialogOpened = true;
    });

    await this.startUp.start();

    this.clinicData.onReload.subscribe(async () => {
      await this.updateNotifyMode()
      await this.setScreenGuard();
      await this.refreshDesktopPetEnabled();
      await this.histService.Init();
    });
    this.clinicData.onParamChanged.subscribe(async n => {
      if (n.some(x => x == 'SYS101')) {
        await this.updateNotifyMode();
        await this.refreshDesktopPetEnabled();
      }
      if (n.some(x => x == 'SYS102')) {
        await this.startUp.updateUIColor();
        this.updateDentalScrollbarColors();
      }
    })
    this.menu = (await this.menuApi.GetMenu()).data
  

    this.updateDentalScrollbarColors();
    await this.setScreenGuard();
    await this.refreshDesktopPetEnabled();
    UserCache.getLoginUser().Menus = this.menu.children;
    this.isLoaded = true;
    if (!UserCache.IsPharmacyMode()) {
      setTimeout(() => void this.startUp.updateLabImport(), 0);
    }
    // 重抓
    this.updatePageTitle();

    setTimeout(() => {
      if (this.histService.isHist) {
        this.isHist = this.histService.isHist;
      }

    }, 500)
    this.isShowPageTitle = BaseConfig.getConfig().env.isShowPageTitle;




  }

  private updateDentalScrollbarColors(): void {
    if (!this.isDental) return;

    const mainColorLuminance = this.getCssColorLuminance('--main-color');
    const mainColorFontLuminance = this.getCssColorLuminance('--main-color-font');
    const mainColorIsLighter = mainColorLuminance == null || mainColorFontLuminance == null
      ? true
      : mainColorLuminance >= mainColorFontLuminance;
    const rootStyle = document.documentElement.style;

    rootStyle.setProperty(
      '--dental-scrollbar-track-color',
      mainColorIsLighter ? 'var(--main-color)' : 'var(--main-color-font)'
    );
    rootStyle.setProperty(
      '--dental-scrollbar-thumb-color',
      mainColorIsLighter ? 'var(--main-color-font)' : 'var(--main-color)'
    );
  }

  private getCssColorLuminance(variableName: string): number | null {
    const probe = document.createElement('span');
    probe.style.color = `var(${variableName})`;
    probe.style.display = 'none';
    document.body.appendChild(probe);

    const resolvedColor = getComputedStyle(probe).color;
    probe.remove();

    const match = resolvedColor.match(/^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:\s*[,/]\s*([\d.]+))?\s*\)$/i);
    if (!match) return null;

    const alpha = match[4] == null ? 1 : Number(match[4]);
    const channels = match.slice(1, 4).map(value => {
      const channel = (Number(value) * alpha + 255 * (1 - alpha)) / 255;
      return channel <= 0.04045
        ? channel / 12.92
        : Math.pow((channel + 0.055) / 1.055, 2.4);
    });

    return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
  }

  async setScreenGuard() {
    var sys101 = await this.clinicData.getParam('SYS101');
    this.screenGuardType = sys101.ScreenGuard ?? 0;
    this.screenGuardWaitS = sys101.ScreenGuardIdleSecond ?? 600;
    if (this.screenGuardType) {
      if (!this.screenGuardTimeout) {
        this.screenGuardTimeout = setInterval(() => {
          console.log('已閒置 ' + this.idleMSCounter + ' 秒');
          this.idleMSCounter++;
          this.showGuard = this.idleMSCounter >= this.screenGuardWaitS;
        }, 1000);

        this.resetScreenGuard();
        window.addEventListener('mousemove', () => {
          this.resetScreenGuard()
        })
        window.addEventListener('click', () => {
          this.resetScreenGuard()
        })
        window.addEventListener('keydown', () => {
          this.resetScreenGuard()
        })
      }
    }
  }

  private async refreshDesktopPetEnabled(): Promise<void> {
    if (!this.isPatientInfoClinic) {
      this.enableDesktopPet = false;
      return;
    }

    try {
      const sys101 = await this.clinicData.getParam('SYS101');
      this.enableDesktopPet = sys101?.EnableDesktopPet === true;
    } catch (_) {
      this.enableDesktopPet = false;
    }
  }

  private async resetScreenGuard() {
    if (this.showGuard) {

      switch (this.screenGuardType) {
        // 直接收起來
        case 1:
          this.idleMSCounter = 0;
          this.showGuard = false;
          break;
        // 其他種關閉方法 ex:輸入密碼
      }
    }

  }
  checkResult: string = ''
  async check(evt: KeyboardEvent) {
    if (evt.key == 'Enter') {
      if (this.screenGuardType == 2) {
        var hash = await SHA256((evt.target as HTMLInputElement).value)
        var check = this.sessionSerivce.getData('HashForCheck');
        if (hash == check) {
          this.idleMSCounter = 0;
          this.showGuard = false;
        } else {
          this.checkResult = '密碼錯誤'
        }
      }
    }
  }
  private routerHandler(router: Router) {
    router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.checkAuth();
        this.updatePageTitle();
        this.patientInfoWindowService.setRouteVisible(this.isPatientInfoWindowRoute(e.urlAfterRedirects || e.url));
      });
  }

  onPatientInfoSelectedPatientChange(patient: PatientListDto) {
    this.patientInfoWindowService.emitSelectedPatientChange(patient);
  }

  onPatientInfoEditPatient(request: PatientInfoWindowEditRequest) {
    if (this.isPatientsEditRoute(this.router.url) || this.isWaitingListRoute(this.router.url)) {
      this.patientInfoWindowService.emitEditPatient(request);
      return;
    }

    this.openPatientInfoEdit(request);
  }

  onPatientInfoReservePatient(request: PatientInfoWindowReserveRequest) {
    if (request?.patient) {
      this.patientInfoWindowService.setSelectedPatient(request.patient);
    }

    const path = this.routeInfoService.makeFullUrl('/registers/reg-reserve');
    setTimeout(() => {
      this.router.navigate([path]);
    }, 0);
  }

  onPatientInfoDentalFollow(request: PatientInfoWindowDentalFollowRequest) {
    this.patientInfoWindowService.emitDentalFollow(request);
  }

  onPatientInfoLayoutChange(layout: PatientInfoWindowLayout | null) {
    this.patientInfoPinnedLayout = layout;
  }

  onPatientInfoResizeStateChange(resizing: boolean) {
    this.patientInfoWindowService.emitResizeStateChange(resizing);
  }

  private isPatientInfoWindowRoute(url: string): boolean {
    const cleanUrl = (url || '').split('?')[0].split('#')[0];
    return cleanUrl.indexOf('/registers/opd-list') >= 0
      || cleanUrl.indexOf('/registers/reg-list') >= 0
      || cleanUrl.indexOf('/registers/reg-reserve') >= 0
      || cleanUrl.indexOf('/registers/patient-care') >= 0
      || cleanUrl.indexOf('/hist/record-dental') >= 0
      || cleanUrl.endsWith('/patients')
      || cleanUrl.indexOf('/patients;') >= 0
      || cleanUrl.indexOf('/patients/edit') >= 0;
  }

  private onPatientInfoReserveRecordNavigation(request: PatientInfoWindowReserveRecordRequest) {
    if (request?.patient) {
      this.patientInfoWindowService.setSelectedPatient(request.patient);
    }

    if (this.isRegReserveRoute(this.router.url)) {
      return;
    }

    const path = this.routeInfoService.makeFullUrl('/registers/reg-reserve');
    const patientId = Number(request?.patientId || request?.patient?.Id || request?.reserveItem?.PatientId || 0);
    const extras = patientId ? { queryParams: { patientId } } : undefined;
    setTimeout(() => {
      this.router.navigate([path], extras);
    }, 0);
  }

  private openPatientInfoEdit(request: PatientInfoWindowEditRequest) {
    const patient = request?.patient;
    const patientId = Number(patient?.Id || request?.registerItem?.PatientId || this.patientInfoWindowState.patientId || 0);
    if (!patientId) {
      return;
    }

    if (patient) {
      this.patientInfoWindowService.setSelectedPatient(patient);
    }

    const path = this.routeInfoService.makeFullUrl('/patients/edit');
    const routeParams: any = {
      mode: this.getPatientInfoEditModeForCurrentRoute(),
      patientId
    };
    if (this.patientInfoPinnedLayout) {
      routeParams.patientInfoPinSide = this.patientInfoPinnedLayout.side;
      routeParams.patientInfoPinSize = this.patientInfoPinnedLayout.size;
    }

    setTimeout(() => {
      this.router.navigate([path, routeParams]);
    }, 0);
  }

  private getPatientInfoEditModeForCurrentRoute(): string {
    const cleanUrl = this.getCleanCurrentUrl();
    if (cleanUrl.indexOf('/registers/reg-list') >= 0) {
      return PatientConst.mode_regList;
    }
    if (cleanUrl.indexOf('/registers/reg-reserve') >= 0) {
      return PatientConst.mode_regReserve;
    }
    if (cleanUrl.indexOf('/registers/opd-list') >= 0) {
      return PatientConst.mode_opdList;
    }

    return PatientConst.mode_basic;
  }

  private isPatientsEditRoute(url: string): boolean {
    return (url || '').split('?')[0].split('#')[0].indexOf('/patients/edit') >= 0;
  }

  private isRegReserveRoute(url: string): boolean {
    return (url || '').split('?')[0].split('#')[0].indexOf('/registers/reg-reserve') >= 0;
  }

  private isWaitingListRoute(url: string): boolean {
    const cleanUrl = (url || '').split('?')[0].split('#')[0];
    return cleanUrl.indexOf('/registers/opd-list') >= 0
      || cleanUrl.indexOf('/registers/reg-list') >= 0;
  }

  private getCleanCurrentUrl(): string {
    return (this.routeInfoService.CurrentUrl || this.router.url || '').split('?')[0].split('#')[0];
  }
  checkAuth() {
    let routeInfo = this.generateRouteInfo();
    if (!routeInfo.data['ignoreActionAuth']) {
      this.getCurrentUserRoleFunctions(routeInfo.url);
    }
  }
  generateRouteInfo() {
    // 從根路由開始，遍歷到最深的活動子路由
    let currentRoute = this.activatedRoute.root;
    let url = ''
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      if (currentRoute.snapshot.url.length) {
        url += '/' + currentRoute.snapshot.url.map(segment => segment.path).join('/');
      }
    }

    return { url, data: currentRoute.snapshot.data };
  }

  private async getCurrentUserRoleFunctions(path: string) {
    
    var result: CustomResult = await this.userRoleFunctionService.checkPath(path);
    if (result.IsSuccess) {
      this.userRoleFunctionService.setUserRoleFunction(result.Object);
    }
    else {
      this.notification.showError(result.Message);
    }
    
  }
  // 要隱藏標題在route 的data設定 hideTitle:true
  private updatePageTitle() {
    let url = this.routeInfoService.CurrentUrl;

    var hidePageTitle = false;
    var r = this.activatedRoute.snapshot;
    while (r.data?.hideTitle != true && r.firstChild) {
      r = r.firstChild;
    }
    hidePageTitle = r.data?.hideTitle;
    if (hidePageTitle) {
      this.pageTitle = ''
      return;
    }
    // route有可能以;做參數傳遞，移除;以後的東西
    const position = url.indexOf(';');
    if (position > 0) {
      url = url.substring(0, position);
    }
    // 分析URL
    const urlParser = new DefaultUrlSerializer();
    const urlTree = urlParser.parse(url);
    const g: UrlSegmentGroup = urlTree.root.children['primary'];
    if (!g || !g.segments) {
      // 根目錄，沒有任何route path
      return;
    }

    const s: UrlSegment[] = g.segments;
    // 取得route path不含Company Code的部分
    // 第一個segment是companyCode
    let path = s.filter((u, i) => i > 0).join('/');
    // 找不到不顯示(個功能額外route到的頁面)
    var pageTitle = ''
    // 將Menu的Text設為PageTitle
    var user = UserCache.getLoginUser();
    if (user.Menus) {

      pageTitle = this.makePageTitle(path, {
        type: 'Node',
        children: user.Menus,
        text: '',
        functionCode: '',
        order: 0,
        id: 0,
        funcSystemId: 1,
      })
    }
    this.pageTitle = pageTitle;
  }
  makePageTitle(url, item: LoginMenu): string {
    if (item.type == 'Link') {
      if (item.path == url) {
        return item.text;
      } else {
        return '';
      }
    } else if (item.type == 'Node') {
      for (let i of item.children ?? []) {
        var childText = this.makePageTitle(url, i);
        if (childText) {
          return item.text ? (item.text + ' > ' + childText) : childText;
        }
      }
      return '';
    }
  }
  onConfirm(code: number) {
    this.error = null;
    this.mainLayoutService.showError(null);
    switch (code) {
      case 401:
        this.auth.logout();
        break;
      case 403:
        // access deny donothing
        break;
      case 404:

        break;
    }
  }
  @ViewChild('confirmDialogYes', { static: false })
  confirmDialogYes: ElementRef<HTMLButtonElement>;
  @ViewChild('confirmDialogNo', { static: false })
  confirmDialogNo: ElementRef<HTMLButtonElement>;
  @ViewChildren('confirmDialogSt')
  confirmDialogSt: QueryList<ElementRef<HTMLButtonElement>>;
  @ViewChildren('confirmDialogMid')
  confirmDialogMid: QueryList<ElementRef<HTMLButtonElement>>;
  @ViewChildren('confirmDialogEnd')
  confirmDialogEnd: QueryList<ElementRef<HTMLButtonElement>>;
  confirmDialogBtns: ElementRef<HTMLButtonElement>[] = [];
  confirmDialogFocusIndex = -1;
  confirmDiagWidth = 250;
  confirmDiagHasAction = true;
  showConfirm = false;
  cusConfirmFn: (ret: boolean) => void = null;
  confirmContent: ConfirmData = new ConfirmData();
  activeElement: Element;
  confirmFocusChagne(evt: KeyboardEvent) {
    if (this.showConfirm) {
      if (this.confirmDialogFocusIndex == -1) {
        this.confirmDialogFocusIndex = 0;
      } else if (evt.key == 'ArrowRight') {
        if (this.confirmDialogBtns.length - 1 > this.confirmDialogFocusIndex) {
          this.confirmDialogFocusIndex++;
        }
      } else if (evt.key == 'ArrowLeft') {
        if (this.confirmDialogFocusIndex > 0) {
          this.confirmDialogFocusIndex--;
        }
      }

      this.confirmDialogBtns.forEach((btn, ind) => {
        if (ind == this.confirmDialogFocusIndex) {
          btn.nativeElement.className = 'confirm-dialog vis-btn-primary default-button';
          btn.nativeElement.focus();
        } else {
          btn.nativeElement.className = '';
        }
      })
      // if(evt.key=='ArrowRight'){
      //   this.confirmDialogNo.nativeElement.className= 'confirm-dialog focus';
      //   this.confirmDialogNo.nativeElement.focus();
      //   this.confirmDialogYes.nativeElement.className= '';
      // }else if(evt.key=='ArrowLeft'){
      //   this.confirmDialogYes.nativeElement.className= 'confirm-dialog focus';
      //   this.confirmDialogNo.nativeElement.className= '';
      //   this.confirmDialogYes.nativeElement.focus();
      // }
    }
  }
  confirmKeyFn: any = null;
  confirmHkFnId: number = null;
  setShowConfirm(show: boolean) {
    if (show) {
      this.loaderComp.isMainlayoutConfirm = true;
      this.showConfirm = true;
    } else {
      this.loaderComp.isMainlayoutConfirm = false;
      this.showConfirm = false;
    }
  }
  showCustomConfirm(data: ConfirmData) {
    this.confirmContent = Object.assign(new ConfirmData(), data);

    // 如果帶入的資料 沒有設定focus，且 (有Yes按鈕，或沒有任何按鈕代表有預設，focus到Yes按鈕)
    if (!this.confirmContent.focus && this.confirmContent.focus !== false && (this.confirmContent.textYes
      || (!this.confirmContent.textYes && !this.confirmContent.textNo && !this.confirmContent.customBtnStart
        && !this.confirmContent.customBtnMid && !this.confirmContent.customBtnEnd))
    ) {
      this.confirmContent.focus = true;
    }
    if (data.restoreFocus) {
      this.activeElement = document.activeElement;
    }

    this.confirmDiagWidth = data.fitContent ? null : data.width || 250;
    // 有Yes/No 額外按鈕的時候才顯示Action
    this.confirmDiagHasAction = !data.hideNo || !data.hideYes ||
      data.customBtnEnd?.length > 0 || data.customBtnMid?.length > 0 ||
      data.customBtnStart?.length > 0;
    // console.log(this.activeElement)
    this.setShowConfirm(true);
    var p = new Promise<boolean | string>((resolve, reject) => {
      this.cusConfirmFn = resolve;
    })
    if (!data.enableInput) {
      this.confirmKeyFn = this.confirmFocusChagne.bind(this);
      window.addEventListener('keydown', this.confirmKeyFn);
    }
    this.confirmHkFnId = this.keyService.regist(Priority.Low, 'None', (k: string) => {
      if (k == 'Escape' && this.snackDiv.length == 0) {
        this.onCustomConfirm(false);
      }
    })
    return p;
  }

  onConfirmOpen() {
    var data = this.confirmContent;
    this.confirmDialogBtns = this.confirmDialogSt.toArray();
    if (this.confirmDialogYes) {
      this.confirmDialogBtns.push(this.confirmDialogYes);
    }
    this.confirmDialogBtns = this.confirmDialogBtns.concat(this.confirmDialogMid.toArray());
    if (this.confirmDialogNo) {
      this.confirmDialogBtns.push(this.confirmDialogNo);
    }
    this.confirmDialogBtns = this.confirmDialogBtns.concat(this.confirmDialogEnd.toArray());
    var focusItem = [{ text: this.confirmContent.textYes || '是', return: 'true' },
    { text: this.confirmContent.textNo || '否', return: 'false' }]
      .concat(this.confirmContent.customBtnStart || [])
      .concat(this.confirmContent.customBtnMid || [])
      .concat(this.confirmContent.customBtnEnd || [])
      .find(it => it.return == '' + data.focus);
    this.confirmDialogBtns.forEach((btn, ind) => {
      if (btn.nativeElement.innerHTML.trim() === focusItem?.text?.trim()) {
        btn.nativeElement.className = 'confirm-dialog vis-btn-primary default-button';
        btn.nativeElement.focus();
        this.confirmDialogFocusIndex = ind;
      } else {
        btn.nativeElement.className = '';
      }
    });
  }
  onCustomConfirm(ret: boolean) {
    // if (ret == null) return; 使用者不選擇 直接關閉，會造成x無法點擊
    this.setShowConfirm(false);

    if (this.confirmHkFnId) {
      this.keyService.unRegist(this.confirmHkFnId)
    }

    if (this.cusConfirmFn) {
      this.cusConfirmFn(ret);
      this.cusConfirmFn = null;
    }


    window.removeEventListener('keydown', this.confirmKeyFn);
    if (this.activeElement) {
      (this.activeElement as any).focus();
    }
  }
  onCustomConfirmClose() {
    if (this.cusConfirmFn) {
      this.cusConfirmFn(false);
      this.cusConfirmFn = null;
    }
    this.setShowConfirm(false);

    window.removeEventListener('keydown', this.confirmKeyFn);
    if (this.activeElement) {
      (this.activeElement as any).focus();
    }
  }
  getErrorCode() {
    if (this.error) {
      return this.error.code;
    }
    return 0;
  }
  getErrorMsg() {
    if (this.error) {
      return this.error.message;
    }
    return '';
  }
  getErrorStatus() {
    if (this.error) {
      return this.error.status;
    }
    return 0;
  }

  ngOnDestroy() {
    document.body.classList.remove('dental-clinic-theme');
    document.documentElement.style.removeProperty('--dental-scrollbar-track-color');
    document.documentElement.style.removeProperty('--dental-scrollbar-thumb-color');
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  hideMenu() {
    if (MenuComponent.Instance != null) {
      MenuComponent.Instance.closeMenu();
    }
  }


  msgs: NotifyMessage[] = []
  msgLog: NotifyMessage[] = []
  @ViewChildren('snackdiv')
  snackDiv: QueryList<ElementRef<HTMLDivElement>>;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(evt: KeyboardEvent) {
    if (evt.key == 'Enter' || evt.key == 'Escape') {
      // console.log(evt);

      if (this.msgs.length > 0) {
        if (evt.target instanceof HTMLButtonElement && !evt.target.classList.contains('mat-menu-item')) {
          evt.target.blur();
        }
        //&& !this.msgs[0].isAutoHide
        this.closeMsg(this.snackDiv.first.nativeElement, 0)
        evt.stopPropagation();
        evt.preventDefault();
      }
    }
  }

  closeMsg(div: HTMLDivElement, index: number) {
    // 把要關閉的訊息掛上動畫class, 交給AnimationStart/End機制處理
    div.classList.remove(this.notifyAnimationClsName + '-delay');
    div.classList.add(this.notifyAnimationClsName);
  }
  isNotifyOnBottom() {
    return this.notifyContainerCls == 'snack-container-bottom';
  }
  收合Msg(div: HTMLDivElement, i: number) {
    div.classList.add('snack-stacked');
    if (this.isNotifyOnBottom()) {
      this.msgs[i].style = {
        bottom: (this.stackPadding * i) + 'px',
        zIndex: 100 + i,
      }
    } else {
      //'snack-container-top'
      this.msgs[i].style = {
        top: (this.stackPadding * i) + 'px',
        zIndex: 100 + i,
      }
    }

  }
  展開Msg(div: HTMLDivElement, i: number) {
    div.classList.remove('snack-stacked');
    this.msgs[i].style = {}
  }
  resetMsgStack() {
    this.msgs.forEach((x, z) => {
      if (this.isNotifyOnBottom()) {
        x.style = {
          bottom: (this.stackPadding * z) + 'px',
          zIndex: 100 + z,
        }
      } else {
        x.style = {
          top: (this.stackPadding * z) + 'px',
          zIndex: 100 + z,
        }
      }
    })
  }
  async 洗牌() {
    if (this.msgs.length <= 2) {
      return;
    }
    return new Promise<boolean>(async (rs, rj) => {
      for (let z = 0; z <= 10; z++) {
        var i = Math.floor(Math.random() * (this.msgs.length - 1))
        var div = this.msgs[i];
        div.style.zIndex = '1000';
        div.style.left = '0px'
        await delay(30);
        div.style.left = '10px'
        await delay(30);
        div.style.left = '15px'
        await delay(30);
        div.style.left = '20px'
        for (let j = i; j < this.msgs.length; j++) {

          for (let k = 0; k < this.stackPadding; k++) {
            if (this.isNotifyOnBottom()) {
              div.style.bottom = (this.stackPadding * (j) + k) + 'px';
            } else {
              div.style.top = (this.stackPadding * (j) + k) + 'px';
            }

            await delay(500 / ((this.msgs.length - i) * this.stackPadding))
          }
        }
        //debugger
        var m = this.msgs.splice(i, 1);
        this.msgs.push(...m);
        div.style = {}
        // div.style.zIndex = null;
        // div.style.bottom = null;
        // div.style.left = null
        await delay(30)
        this.resetMsgStack();
      }

    });
  }
  executeMoreClick(msg: NotifyMessage) {
    if (msg?.onMoreClick) {
      msg.onMoreClick();
    }
  }
  public closeMsgById(id: string) {
    var index = this.msgs.findIndex(x => x.id == id);
    if (index >= 0) {
      this.onAniEnd(null, index);
      //this.closeMsg(this.snackDiv.get(index).nativeElement,index);
    }
  }
  async updateNotifyMode() {
    var sys101 = await this.clinicData.getParam('SYS101')
    this.notifyAnimationClsName = sys101.NotifyPosition == 'bottom' ? 'snack-slideout' : 'snack-fadeout'
    this.notifyContainerCls = sys101.NotifyPosition == 'bottom' ? 'snack-container-bottom' : 'snack-container-top'
    this.notifyStack = sys101.NotifyStack;
    this.isSupportedNotifyStyle = ['bottom', 'top', '', null].includes(sys101.NotifyPosition);
    if (this.notifyStack) {
      this.notifyAnimationClsName = 'snack-fadeout'
    }
  }
  notifyStack = false;
  isSupportedNotifyStyle = true;
  stackPadding = 10;
  notifyAnimationClsName = 'snack-fadeout';//snack-fadeout-delay
  notifyContainerCls = 'snack-container'
  onAniEnd(evt, index) {
    // 移除訊息
    this.msgs.splice(index, 1);
    if (this.notifyStack) {
      this.resetMsgStack();
    }
  }
  onAniStart(evt: AnimationEvent, index: number) {
    if (evt.animationName == "fadeout") {
    }
  }
  shownoty(type: number) {
    if (type == 1) {
      this.notification.showSuccess('成功！');
    } else if (type == 2) {
      this.notification.showError('來測試看看文字太長會長成甚麼樣子究竟到底會不會跑版又或者抑或是會左右延展還是說會變成兩行產生動畫的錯誤>"<');
    } else if (type == 3) {
      this.notification.showInfo('~~~~~~~~~~~~~~~~提示~~~~~~~~~~~~~~~~');
    }
  }



  async getFontGreater($event) {
    await this.fontGreatService.switchFontGreat();
  }

  initCondition: {CName:string,CId:string,Mobile:string,Birthday:Date} = null;
  isPatientDialogOpened = false;
  patientSelectResolve: (s: PatientListDto) => void = null;
  patientSelectReject: (s: any) => void = null;
  patientSelectNotFoundHandler: ((event: QueryPatient) => Promise<boolean>) = null;

  selectPatient(
    initCondition: {CName:string,CId:string,Mobile:string,Birthday:Date}=null,
    onQueryNotFound?: (event: QueryPatient) => Promise<boolean>
  ): Promise<PatientListDto> {
    this.initCondition = initCondition;
    this.patientSelectNotFoundHandler = onQueryNotFound;
    this.isPatientDialogOpened = true;
    var p = new Promise<PatientListDto>((rs, rj) => {
      this.patientSelectResolve = rs;
      this.patientSelectReject = rj;
    });
    return p;
  }
  onPatientDialogClose(evt: PatientListDto) {
    this.isPatientDialogOpened = false;
    this.initCondition = null;
    this.patientSelectNotFoundHandler = null;
    if (this.patientSelectResolve) {
      this.patientSelectResolve(evt);
    }
    this.patientSelectResolve = null;
    this.patientSelectReject = null;

  }

  async onPatientQueryNotFound(event: QueryPatient) {
    if (!this.patientSelectNotFoundHandler) {
      return;
    }

    const shouldContinue = await this.patientSelectNotFoundHandler(event);
    if (shouldContinue) {
      this.onPatientDialogClose(null);
    }
  }


  tipObj: TipModel = null;
  tipPosTimeInterval: any;
  tipBorderStyle = {};
  updateTipPos() {
    if (!this.tipObj) return;
    if (!document.getElementById(this.tipObj.target.id)) {
      this.setTip(null, '', false);
      return;
    }
    var c = this.tipObj.target;
    var x = 0;
    var y = 0;
    var c = this.tipObj.target;
    while (c != null) {
      x += c.offsetLeft;
      y += c.offsetTop;
      c = c.offsetParent as HTMLElement;
    }

    var c = this.tipObj.target;
    while (c != null) {
      y -= c.scrollTop
      c = c.parentElement as HTMLElement;
    }
    var showBorder = y < window.innerHeight && x < window.innerWidth;
    //y+=o.target.clientHeight;
    //y-=60;
    //x+=o.target.clientWidth/2
    var contentFix = '';
    var msgy = y - 70;
    if (msgy < 60) {
      msgy = y + this.tipObj.target.clientHeight + 10;
    }
    if (msgy < 50) {
      msgy = 50;
      contentFix = showBorder ? '' : '(請向上捲動)'
    }
    if (msgy > window.innerHeight - 60) {
      contentFix = showBorder ? '' : '(請向下捲動)'
      msgy = window.innerHeight - 60;
    }

    var msgW = 40 + 80; // padding + button
    var msgx = x - 10;
    var fontSize = 18;
    for (let i = 0; i <= (this.tipObj.content + contentFix).length; i++) {
      var ch = (this.tipObj.content + contentFix).charAt(i)
      if (ch.match(/[^\x00-\xff]/g)) {
        msgW += fontSize;
      } else {
        msgW += (fontSize / 2 * 1.1);
      }
    }
    // 20 scrollbar
    if (msgx + msgW > window.innerWidth - 10) {
      msgx = window.innerWidth - msgW - 10;
    }
    var borderHeight = this.tipObj.target.clientHeight + 20;

    this.tipObj.contentFix = contentFix,

      this.tipObj.msgX = msgx;
    this.tipObj.msgY = msgy;
    this.tipObj.borderX = x - 10;
    this.tipObj.borderY = y - 10;
    this.tipObj.h = borderHeight;
    this.tipObj.w = this.tipObj.target.clientWidth + 20;
    this.tipObj.showBorder = showBorder;
    this.tipObj.hidden = false;
    var borderColor = '#4444'
    this.tipBorderStyle = {
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      borderLeft: this.tipObj.borderX + 'px solid ' + borderColor,
      borderTop: this.tipObj.borderY + 'px solid ' + borderColor,
      borderBottom: (window.innerHeight - this.tipObj.borderY - this.tipObj.h) + 'px solid ' + borderColor,
      borderRight: (window.innerWidth - this.tipObj.borderX - this.tipObj.w) + 'px solid ' + borderColor
    }

  }
  setTip(o: TutorialTip, name: string, isLast: boolean) {
    if (this.tipPosTimeInterval != null) {
      clearInterval(this.tipPosTimeInterval);
    }
    if (o == null) {
      this.tipObj = null;
      return;
    }
    var tar = document.getElementById(o.target);
    if (!tar) {
      return;
    }
    this.tipObj = new TipModel();
    this.tipObj.content = o.content,
      this.tipObj.cssCls = o.cssCls,
      this.tipObj.target = tar;
    this.tipObj.name = name;
    this.tipObj.isLast = isLast;
    this.tipObj.hidden = true;
    this.tipPosTimeInterval = setInterval(() => {
      this.updateTipPos();
    }, 30);
  }

  nextTip(name: string) {

    this.tutorialService.Next(name)
  }

  contentHeight() {
    return this.mainContent.nativeElement.clientHeight;
  }

  qrCodeResultCallBack: (string) => void = null;
  qrCodeCloseEvtSubs: Subscription;
  //qrCodeOpenEvtSubs:Subscription;
  showScanner = false;
  async openQRCodeScanner(): Promise<string> {
    this.showScanner = true;
    // if(!this.qrCodeOpenEvtSubs){
    //   this.qrCodeOpenEvtSubs = this.QRCodeReader.open.subscribe(()=>{

    //   })
    // }
    if (!this.qrCodeCloseEvtSubs) {
      this.qrCodeCloseEvtSubs = this.QRCodeScanner.close.subscribe(() => {
        if (this.qrCodeResultCallBack) {
          this.qrCodeResultCallBack('');
          this.qrCodeResultCallBack = null;
        }

        this.qrCodeCloseEvtSubs.unsubscribe();
        this.qrCodeCloseEvtSubs = null;
        // this.qrCodeOpenEvtSubs?.unsubscribe();
        // this.qrCodeOpenEvtSubs = null;
        this.showScanner = false;
      })
    }
    this.QRCodeScanner.show = true;


    return new Promise<string>((rs, rj) => {
      this.qrCodeResultCallBack = rs;
    })

  }
  closeQRCodeScanner() {
    this.QRCodeScanner.show = false;
  }
  async onQRCodeScanResult(code: string) {
    if (this.qrCodeResultCallBack) {
      this.qrCodeResultCallBack(code);
      this.showScanner = false

    }
  }
  async openQRCodeReader(): Promise<string> {
    this.QRCodeReader.reset();
    this.QRCodeReaderDiag.show = true;
    return new Promise<string>((rs, rj) => {
      this.qrCodeResultCallBack = rs;
    })

  }
  closeQRCodeReader() {
    this.QRCodeReaderDiag.show = false;
  }

  playNotifySound() {
    if (this.notifySound) {
      this.notifySound.play();
    }
  }

  get stockAlertDialogTitle(): string {
    return this.showBatchExpiryTab ? '庫存警示' : '庫存不足提示';
  }

  get batchExpiryAlertCount(): number {
    return this.stockAlertCounts
      ? this.stockAlertCounts.BatchNearExpiryCount + this.stockAlertCounts.BatchExpiredCount
      : 0;
  }

  /** 庫存警示 dialog 可用 Esc 關閉：展示模式或管理者/超級使用者 */
  get stockAlertCloseOnEsc(): boolean {
    const user = UserCache.getLoginUser();
    return this.hcrService.isDemoMode || !!(user.IsAdmin || user.IsSuper);
  }

  onStockAlertDialogClose() {
    this.isStockAlertDialogOpened = false;
  }

  // 閒置批號頁籤停用成功: 以剩餘筆數更新徽章
  onInactiveBatchStopped(remaining: number) {
    if (this.stockAlertCounts) {
      this.stockAlertCounts.InactiveBatchCount = remaining;
    }
  }

}
class TipModel {
  content: string;
  contentFix: string = '';
  target: HTMLElement;
  cssCls: string;
  msgX: number = 0;
  msgY: number = 0;
  hidden: boolean = true;
  borderX: number = 0;
  borderY: number = 0;
  showBorder: boolean = false;
  w: number = 0;
  h: number = 0;
  name: string;
  isLast: boolean;
}
